import {applyFunctionsToScope, registerScopeFunction} from "../util/scope";
import './global';
import './index.desktop.css';
import {setUpShareButtonsDesktop} from "./dataset/standard/share";

registerScopeFunction(setUpShareButtonsDesktop);

// run functions on global scope
applyFunctionsToScope(document);
